import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Spinner, Alert, Badge } from 'react-bootstrap';
import { publicAPI } from '../services/api';

const Faculty = () => {
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    fetchStaff();
  }, []);

  const fetchStaff = async () => {
    try {
      setLoading(true);
      const result = await publicAPI.getStaff();
      if (result && result.success) {
        setStaff(result.data || []);
      } else {
        setError('Failed to load staff information');
      }
    } catch (error) {
      console.error('Error fetching staff:', error);
      setError('Network error. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container className="py-5">
      <h1 className="display-4 mb-4 text-center">Our Faculty</h1>
      <p className="lead text-center mb-5">
        Meet our dedicated and experienced faculty members
      </p>

      {error && (
        <Alert variant="danger" className="mb-4">
          {error}
        </Alert>
      )}

      {loading ? (
        <div className="text-center py-5">
          <Spinner animation="border" variant="primary" />
          <p className="mt-3">Loading faculty information...</p>
        </div>
      ) : staff.length > 0 ? (
        <Row>
          {staff.map((member) => (
            <Col key={member.id} lg={4} md={6} className="mb-4">
              <Card className="h-100 shadow-sm card-hover">
                <Card.Body className="text-center">
                  {member.profile_photo ? (
                    <img 
                      src={member.profile_photo} 
                      alt={member.name}
                      className="rounded-circle mb-3"
                      style={{ width: '150px', height: '150px', objectFit: 'cover' }}
                    />
                  ) : (
                    <div className="rounded-circle bg-primary text-white d-flex align-items-center justify-content-center mb-3 mx-auto"
                      style={{ width: '150px', height: '150px' }}>
                      <i className="fas fa-user fa-3x"></i>
                    </div>
                  )}
                  
                  <Card.Title className="mb-2">
                    {member.name}
                  </Card.Title>
                  
                  {member.designation && (
                    <Card.Subtitle className="mb-3 text-muted">
                      <Badge bg="info" className="me-2">
                        {member.designation}
                      </Badge>
                    </Card.Subtitle>
                  )}
                  
                  <div className="text-start">
                    {member.qualification && (
                      <p className="mb-2">
                        <strong>Qualification:</strong> {member.qualification}
                      </p>
                    )}
                    
                    {member.experience_years && (
                      <p className="mb-2">
                        <strong>Experience:</strong> {member.experience_years} years
                      </p>
                    )}
                    
                    {member.department && (
                      <p className="mb-2">
                        <strong>Department:</strong> {member.department}
                      </p>
                    )}
                    
                    {member.email && (
                      <p className="mb-0">
                        <strong>Email:</strong> {member.email}
                      </p>
                    )}
                  </div>
                </Card.Body>
              </Card>
            </Col>
          ))}
        </Row>
      ) : (
        <div className="text-center py-5">
          <i className="fas fa-users fa-3x text-muted mb-3"></i>
          <h3>No Faculty Information Available</h3>
          <p className="text-muted">Faculty profiles will be updated soon.</p>
        </div>
      )}
    </Container>
  );
};

export default Faculty;